(() => {
  const initial = () => {
    document.querySelectorAll('product-info').forEach(info => {
      const legacy = info.querySelector('[data-bff-tier]');
      const pickerBlock = info.querySelector('.main-product__block-variant_picker');
      if (legacy && pickerBlock && !pickerBlock.contains(legacy)) pickerBlock.appendChild(legacy);
      const choices = info.querySelector('[data-bff-native-formats]');
      if (!choices || info.dataset.bffFormatsReady) return;
      info.dataset.bffFormatsReady = 'true';
      const requested = new URLSearchParams(location.search).has('variant');
      const deluxe = choices.querySelector('input[value="Deluxe"]');
      if (!requested && deluxe && !deluxe.disabled && !deluxe.checked) {
        deluxe.checked = true;
        deluxe.dispatchEvent(new Event('change', {bubbles:true}));
      } else if (info.currentVariant) {
        info.updateMedia(info.currentVariant);
      }
    });
  };
  if(document.readyState === 'complete') initial(); else window.addEventListener('load', initial, {once:true});
  document.addEventListener('shopify:section:load', initial);
})();